import {
  FullEventFragment,
  PaymentSubscriptionFragment,
  useCreateSubscriptionCheckoutSessionMutation,
} from '@/generated/graphql';
import { formatPrice } from '@/utils/formatPrice';
import { ValuePropCard } from './ValuePropCard';
import { useState } from 'react';

export function PaymentSubscriptionCard({
  subscription,
  price,
}: {
  subscription: PaymentSubscriptionFragment | null | undefined;
  price: number;
  event: FullEventFragment;
  onEventLive: () => void;
}) {
  const cardHeading = 'Subscription';
  const [createSubscriptionCheckoutSession] =
    useCreateSubscriptionCheckoutSessionMutation();

  const [creatingSession, setCreatingSession] = useState(false);

  const className = subscription
    ? 'border-muted bg-muted/80'
    : 'border-epic bg-epic/80';

  const description = subscription
    ? `You already have a subscription but are currently running the max number of live screens (${subscription.maxConcurrentEvents}).`
    : 'Go live anytime! Up to 5 live screens at a time.';

  const buttonText = subscription
    ? null
    : `Subscribe for ${formatPrice(price)}/mo`;

  const buttonAction = subscription
    ? null
    : () => {
        createSubscriptionCheckoutSession({
          variables: {
            data: {
              successUrl: window.location.href,
              cancelUrl: window.location.href,
            },
          },
        })
          .then(({ data }) => {
            if (data?.createSubscriptionCheckoutSession?.url) {
              window.location.href = data.createSubscriptionCheckoutSession.url;
            }
          })
          .finally(() => {
            setCreatingSession(false);
          });
      };

  return (
    <ValuePropCard
      icon="🔃"
      heading={cardHeading}
      description={description}
      buttonText={buttonText}
      buttonAction={buttonAction}
      buttonDisabled={creatingSession}
      className={className}
    />
  );
}
